import { ReactElement } from 'react';
import Button from '../controls/Button';

type InfoCardProps = {
  title: string;
  description: string;
  buttonFunction?: () => void;
  buttonText?: string;
  tipPosition?: 'left' | 'right';
};

/**
 * A card component for displaying information with a title, description, and action button.
 * @param  props - Properties of InfoCard Component.
 * @returns  A React element representing the InfoCard component.
 */
export default function InfoCard(props: InfoCardProps): ReactElement {
  const { title, description, buttonFunction, tipPosition, buttonText } = props;
  return (
    <div className="py-1 bottom-2 relative">
      <div className="w-full h-6 relative ">
        <div
          /* TODO:have to fix fixed width and height below class */
          className={`w-10 inline-block absolute top-1 ${
            tipPosition === 'right' ? 'right-0' : 'left-0'
          }`}
        >
          <div className=" h-6 w-6 bg-white rotate-45 transform origin-bottom-left dark:bg-background-600" />
        </div>
      </div>
      <div className="bg-white p-4 rounded border border-gray-100 dark:bg-background-600 dark:border-background-500 shadow shadow-gray-600 dark:shadow-gray-900 w-80">
        <p className="text-gray-900 text-lg font-bold dark:text-white">{title}</p>
        <p className="text-base font-normal text-gray-500 dark:text-gray-300 mb-4">{description}</p>
        {buttonFunction ? (
          <Button theme="primary" size="sm" name={buttonText || 'View'} onClick={buttonFunction} />
        ) : (
          ' '
        )}
      </div>
    </div>
  );
}
